import { useState } from "react";
import API from "../services/api";
import jsPDF from "jspdf";

export default function ResultHistory() {
  const [studentId, setStudentId] = useState("");
  const [results, setResults] = useState([]);

  const fetchResults = async () => {
    try {
      const res = await API.get(`/exams/${studentId}`);
      setResults(res.data);
    } catch (err) {
      alert("Unable to fetch result history");
    }
  };

  const totalObtained = results.reduce(
    (sum, item) => sum + Number(item.marks_obtained),
    0
  );

  const totalMarks = results.reduce(
    (sum, item) => sum + Number(item.total_marks),
    0
  );

  const percentage =
    totalMarks > 0
      ? ((totalObtained / totalMarks) * 100).toFixed(2)
            : 0;

    const downloadReportCard = () => {
        const doc = new jsPDF();

        doc.setFontSize(16);
        doc.text("Student Report Card", 20, 20);

        doc.setFontSize(12);
        doc.text(`Student ID: ${studentId}`, 20, 40);
        doc.text(`Total Obtained: ${totalObtained}`, 20, 55);
        doc.text(`Total Marks: ${totalMarks}`, 20, 70);
        doc.text(`Percentage: ${percentage}%`, 20, 85);

        let y = 105;

        results.forEach((item, index) => {
            doc.text(
                `${index + 1}. ${item.subject} - ${item.marks_obtained}/${item.total_marks}`,
                20,
                y
            );
            y += 10;
        });

        doc.text("Generated by School ERP System", 20, y + 20);

        doc.save(`ReportCard_${studentId}.pdf`);
    };



  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-6">
        Student Result History
      </h1>

      <div className="bg-white shadow p-6 rounded mb-6">
        <input
          placeholder="Enter Student ID"
          value={studentId}
          onChange={(e) => setStudentId(e.target.value)}
          className="border p-2 w-full mb-4"
        />

        <button
          onClick={fetchResults}
          className="bg-blue-600 text-white px-4 py-2 rounded"
        >
          View Results
        </button>
      </div>

      <div className="bg-white shadow p-6 rounded mb-6">
        <h2 className="text-lg font-semibold">
          Total Obtained: {totalObtained}
        </h2>

        <h2 className="text-lg font-semibold">
          Total Marks: {totalMarks}
        </h2>

        <h2 className="text-lg font-semibold">
          Percentage: {percentage}%
              </h2>
        <button
                  onClick={downloadReportCard}
                  className="bg-green-600 text-white px-4 py-2 rounded mt-4"
              >
                  Download Report Card PDF
         </button>
      </div>

      <div className="bg-white shadow p-6 rounded">
        <table className="w-full border">
          <thead>
            <tr className="bg-gray-100">
              <th>Exam Type</th>
              <th>Subject</th>
              <th>Obtained</th>
              <th>Total</th>
              <th>Date</th>
            </tr>
          </thead>

          <tbody>
            {results.map((item) => (
              <tr key={item.id}>
                <td>{item.exam_type}</td>
                <td>{item.subject}</td>
                <td>{item.marks_obtained}</td>
                <td>{item.total_marks}</td>
                <td>{item.exam_date}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}